var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../vue-loader/lib/style-rewriter.js?id=_v-35bdfbc4&scoped=true!../../vue-loader/lib/selector.js?type=style&index=0!./Select.vue")
__vue_script__ = require("!!babel!eslint!../../vue-loader/lib/selector.js?type=script&index=0!./Select.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] node_modules/vue-strap/src/Select.vue: named exports in *.vue files are ignored.")}
__vue_template__ = require("!!vue-html-loader!../../vue-loader/lib/template-rewriter.js?id=_v-35bdfbc4!../../vue-loader/lib/selector.js?type=template&index=0!./Select.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  var id = "_v-35bdfbc4/Select.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


//////////////////
// WEBPACK FOOTER
// ./~/vue-strap/src/Select.vue
// module id = 88
// module chunks = 0